import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import Loader from '../../../Utilities/Loader/Loader';

import './WeightChart.css';
import 'chartjs-plugin-labels';

function WeightChart(props) {

  const chartLabel = ['Top 10', 'Autres Compagnies'];
  const [chartData, setChartData] = useState({
    top10: '0',
    remaining: '0'
  });

  useEffect(() => {
    setChartData({
      top10: props.weightChartData.top10,
      remaining: props.weightChartData.remaining
    });

    // document.getElementsByClassName('pie').innerText = `HEY!`;
  }, [props]);


  const pieChartData = {
    labels: chartLabel,
    datasets: [
      {
        data: [parseFloat(chartData.remaining).toFixed(2), parseFloat(chartData.top10).toFixed(2)],
        backgroundColor: ['#E9CBBC', '#D4610C'],
        borderWidth: '1px'
      }
    ]
  }

  const pieChartOptions = {
    rotation: (0.4 * Math.PI),
    legend: {
      display: false
    },
    plugins: {
      labels: {
        render: function (args) {
          // args will be something like:
          // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
          if(args.label === 'Top 10') {
            return `Top 10:` + args.percentage + `%`;
          }

          return '';
        },
        fontSize: window.screen.availWidth <= 700? 25: 15,
        fontColor: '#FCFAF9',
        fontStyle: 'bold'
      }
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      titleFontSize: window.screen.availWidth <= 700 ? 30: 15,
      bodyFontSize: window.screen.availWidth <= 700 ? 30: 15,
      callbacks: {
        title: function(tooltipItem) { 
          return chartLabel[tooltipItem[0].index];
        },
        label: function(tooltipItem, data) { 
          let val = data.datasets[0].data[tooltipItem.index];
          return val + '%';
        },
      }
    }
  }

  return (
    <div>
      <div id="weightChart">
        <div class="chartContainer">
          <div class="pieChart">
            {!chartData && <div class="loader"><Loader /></div>}
            <div class="pie">
            {chartData &&
              <Pie
                data={pieChartData} 
                options={pieChartOptions}
              />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WeightChart;
